<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-xs">
        <h2 class="mt-0">100% Money-Back Guarantee</h2>
        <p>Stuff happens- priorities change, clients go AWOL, natural disasters strike... you need to ensure you're covered.</p>
        <p>That's why I offer a 100% money-back guarantee you can use to eject, even in the middle of a project with me.</p>
        <p>
          <strong>The only caveat is you're on the hook for Stripe's own fees.</strong>They're the payment processor of choice for every developer, but they don't refund processing fees (neither do their major competitors, I checked).
        </p>
        <p>Other than that, you can ask for a refund at any stage before I've handed off the code to you or your client. Simple as that.</p>
        <h4>Examples of situations in which you're covered:</h4>
        <ul>
          <li>The nature of your client's business changes in a big way and building an MVP suddenly doesn't make much sense</li>
          <li>Your client suddenly stops answering emails or paying invoices</li>
          <li>Your relationship with the client changes and you need to eject from the project</li>
        </ul>
        <p>These are extreme occurences, and to be honest I've never actually been called on to issue a refund before. But there's a first time for everything, and you can rest assured you're off the hook (minus the fees Stripe charges me for processing your payment in the first place).</p>
      </div>
    </c-generic-section>

    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
import CGenericSection from "@/components/sections/GenericSection.vue";
import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Secondary",
  components: {
    CGenericSection,
    CCta
  },
  data() {
    return {};
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
